import { useAppNavigation } from "@hooks/use-app-navigation";
import { sentryCaptureError } from "@utils/sentry-utils";
import { getUlmRouteFromUserModule } from "@utils/user-module-converter-utils";
import { useEffect } from "react";

/**
 * Converts the url that is redirected from the user module to the url usable in the Entry Page.
 * It will redirect to the correct page and will keep all query parameters.
 */
export function UserModuleConverter(): JSX.Element | null {
  const { navigateToRoute } = useAppNavigation();

  useEffect(() => {
    function navigateToCorrectRoute(): void {
      const hash = window.location.hash;

      if (
        !window.location.href.includes("user-module") &&
        !window.location.href.includes("dashboard-login")
      ) {
        // If the route does not include "user-module" is because the page was already redirected.
        // This happens specially in localhost due to useEffect being called twice
        return;
      }

      const { route, additionalQuery, shouldShowError } =
        getUlmRouteFromUserModule({ hash });

      if (shouldShowError) {
        sentryCaptureError({
          error: {
            url: window.location.href,
            hash: window.location.hash,
          },
          title: "Invalid redirection from user-module",
        });
      }

      navigateToRoute({
        route,
        additionalQuery,
      });
    }

    navigateToCorrectRoute();
  }, [navigateToRoute]);

  return null;
}
